import axios from "axios";

export default axios.create({ baseURL: "https://lj7enz6qhfgc3bqqqa3tm4ra6i.appsync-api.ap-south-1.amazonaws.com/" })
